import { ActionType, createReducer } from 'typesafe-actions'
import {
  createMessageAsync,
  deleteEditMessageHandle,
  deleteMessageHandle,
  editMessageHandle,
  editTextMessageHandle,
  fetchMessageTemplatesHandle,
  fetchMoreMessagesAsync,
  fetchQuickReplyMessagesHandle,
  reSendMessageHandle,
  replyHandle,
  setHasMoreMessages
} from './actions'
import { MessageAction, MessageState } from './types'

const initialState: MessageState = {
  quickReplies: [],
  messages: [],
  isLoading: false,
  error: false,
  hasMoreMessages: false,
  isLoadingFetchMore: false,
  isErrorOnCreateMessage: false,
  isLoadingCreateMessage: false,
  isSuccessCreateMessage: false,
  isLoadingAttachment: false,
  isLoadingAudio: false,
  isLoadingText: false,
  isLoadingSticker: false,
  isLoadingSendMessageTemplate: false,
  messageTemplates: [],
  isErrorOnFetchMessageTemplates: false,
  isLoadingOnFetchMessageTemplates: false,
  isSuccessOnFetchMessageTemplates: false,
  isErrorOnReSendMessage: false,
  isLoadingOnReSendMessage: false,
  isSuccessOnReSendMessage: false,
  replyMessage: null,
  isLoadingOnDeleteMessage: false,
  isErrorOnDeleteMessage: false,
  isSuccessOnDeleteMessage: false,
  editMessage: null,
  isLoadingOnEditTextMessage: false,
  isErrorOnEditTextMessage: false,
  isSuccessOnEditTextMessage: false,
  isLoadingContact: false,
  isLoadingLocation: false,
  isErrorOnFetchQuickReplyMessages: false,
  isLoadingOnFetchQuickReplyMessages: false,
  isSuccessOnFetchQuickReplyMessages: false
}

export const messageReducer = createReducer<MessageState, MessageAction>(initialState)
  .handleAction(
    createMessageAsync.request,
    (state: MessageState, action: ActionType<typeof createMessageAsync.request>): MessageState => ({
      ...state,
      isLoading: true,
      isLoadingCreateMessage: true,
      isLoadingContact: action.payload?.typeFile === 'contact',
      isLoadingAttachment: action.payload?.typeFile === 'attachment',
      isLoadingAudio: action.payload?.typeFile === 'audio',
      isLoadingText: action.payload?.typeFile === 'text',
      isLoadingSticker: action.payload?.typeFile === 'sticker',
      isLoadingSendMessageTemplate: action.payload?.typeFile === 'messageTemplate',
      isLoadingLocation: action.payload?.typeFile === 'location'
    })
  )
  .handleAction(
    createMessageAsync.success,
    (state: MessageState): MessageState => ({
      ...state,
      isLoading: false,
      isSuccessCreateMessage: true,
      isLoadingAttachment: false,
      isLoadingAudio: false,
      isLoadingText: false,
      isLoadingSendMessageTemplate: false,
      isLoadingSticker: false,
      isLoadingContact: false,
      isLoadingLocation: false,
      replyMessage: null,
      editMessage: null
    })
  )
  .handleAction(
    createMessageAsync.failure,
    (state: MessageState, { payload }: ActionType<typeof createMessageAsync.failure>): MessageState => {
      return {
        ...state,
        isLoading: false,
        error: true,
        isErrorOnCreateMessage: true,
        isLoadingCreateMessage: false,
        isLoadingAttachment: false,
        isLoadingContact: false,
        isLoadingAudio: false,
        isLoadingText: false,
        isLoadingSticker: false,
        isLoadingLocation: false,
        isLoadingSendMessageTemplate: false,
        replyMessage: null,
        editMessage: null
      }
    }
  )
  .handleAction(
    fetchMoreMessagesAsync.request,
    (state: MessageState): MessageState => ({
      ...state,
      hasMoreMessages: false,
      isLoadingFetchMore: true
    })
  )
  .handleAction(
    fetchMoreMessagesAsync.failure,
    (state: MessageState): MessageState => ({
      ...state,
      isLoadingFetchMore: false
    })
  )
  .handleAction(
    setHasMoreMessages,
    (state: MessageState, action: ActionType<typeof setHasMoreMessages>): MessageState => ({
      ...state,
      isLoading: false,
      error: null,
      hasMoreMessages: action.payload.state,
      isLoadingFetchMore: false
    })
  )
  .handleAction(fetchMessageTemplatesHandle.asyncAction.request, fetchMessageTemplatesHandle.request)
  .handleAction(fetchMessageTemplatesHandle.asyncAction.success, fetchMessageTemplatesHandle.success)
  .handleAction(fetchMessageTemplatesHandle.asyncAction.failure, fetchMessageTemplatesHandle.failure)
  .handleAction(reSendMessageHandle.asyncAction.request, reSendMessageHandle.request)
  .handleAction(reSendMessageHandle.asyncAction.success, reSendMessageHandle.success)
  .handleAction(reSendMessageHandle.asyncAction.failure, reSendMessageHandle.failure)
  .handleAction(replyHandle.asyncAction, replyHandle.success)
  .handleAction(deleteMessageHandle.asyncAction.request, deleteMessageHandle.request)
  .handleAction(deleteMessageHandle.asyncAction.success, deleteMessageHandle.success)
  .handleAction(deleteMessageHandle.asyncAction.failure, deleteMessageHandle.failure)
  .handleAction(editMessageHandle.asyncAction, editMessageHandle.success)
  .handleAction(editTextMessageHandle.asyncAction.request, editTextMessageHandle.request)
  .handleAction(editTextMessageHandle.asyncAction.success, editTextMessageHandle.success)
  .handleAction(editTextMessageHandle.asyncAction.failure, editTextMessageHandle.failure)
  .handleAction(deleteEditMessageHandle.asyncAction, deleteEditMessageHandle.success)
  .handleAction(fetchQuickReplyMessagesHandle.asyncAction.request, fetchQuickReplyMessagesHandle.request)
  .handleAction(fetchQuickReplyMessagesHandle.asyncAction.failure, fetchQuickReplyMessagesHandle.failure)
  .handleAction(fetchQuickReplyMessagesHandle.asyncAction.success, fetchQuickReplyMessagesHandle.success)
